export default __webpack_public_path__ + "static/media/Vambraces of the Martial Paragon.0b8e4aa3.jpg";